import React, { FC } from 'react'
import i18n from 'i18next'
import { MemberApi } from '@api/index'
import { modalLayer } from '@utils'
import ClauseDetail from '../ClauseDetail'
import './index.scss'

interface IProps {
  terms: IClauseInfo;
  isCheck: boolean;
  showTip?: boolean;
  onChange: (check: boolean) => void;
}

const TermsTick: FC<IProps> = (props: IProps) => {
  const { terms, isCheck, showTip, onChange } = props
  const getClauseDetail = () => {
    MemberApi.getClauseDetail({ applyScope: terms.applyScope }).then((res) => {
      modalLayer(ClauseDetail, { info: res }, 'ClauseDetail').then(() => { }).catch(() => { })
    })
  }
  return (
    <div className='mkt-terms-tick'>
      {showTip && <div className='tip'><span>{i18n.t('mkt.member.termsTickTip', { name: terms.clauseName })}</span></div>}
      <i data-cypid='mmgCheckTermsTick' onClick={() => onChange(!isCheck)} className={`iconfont ${isCheck ? 'icon-duigou' : 'icon-checkbox'}`}></i>
      <span>{i18n.t('mkt.member.termsTick')}</span>
      《<span data-cypid='mmgToTermsTickDetail' className='terms' onClick={getClauseDetail}>{terms.clauseName}</span>》
    </div>
  )
}

export default TermsTick
